import Cookies from 'js-cookie'
import { getSmsCount, setSmsCount, getExpoConfig } from '../../utils/storage'

var u = navigator.userAgent

const env = {
  state: {
    isMacOS: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
    isAndroid: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1,
    isWX: u.indexOf('MicroMessenger') > -1,
    isMobile: /Mobile|Android|iPhone|iPad|Phone/i.test(u),
    isMiniProgram: u.indexOf('miniProgram') > -1,
    isLoading: false,
    isDebug: false,
    wxSignUrl: '',
    language: '',
    smsCount: getSmsCount(),
    offsetWidth: document.body.offsetWidth,
    offsetHeight: document.body.offsetHeight,
    expoConfig: getExpoConfig()
  },
  mutations: {
    SET_WXSIGN_URL: (state, url) => {
      state.wxSignUrl = url
    },
    UPDATE_LOADING_STATUS: (state, payload) => {
      state.isLoading = payload.isLoading
    },
    SET_DEBUG: (state, debug) => {
      state.isDebug = debug
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set('language', language)
    },
    INCR_SMS_COUNT: (state) => {
      state.smsCount += 1
      setSmsCount(state.smsCount)
    },
    SET_OFFSET_HEIGHT: (state) => {
      state.offsetHeight = document.body.offsetHeight
    }
  },
  actions: {
    SetWxSignUrl({ commit }, url) {
      commit('SET_WXSIGN_URL', url)
    },
    SetDebug({ commit }, debug) {
      commit('SET_DEBUG', debug)
    }
  }
}

export default env



// WEBPACK FOOTER //
// ./src/store/modules/env.js